var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H19.9977V2.00225H15V0.5H14V2.00225H6V0.5H5V2.00225H0.00224996V6H0V7H0.00224996V17.9977H19.9977V7H20V6ZM0.99775 2.99775H5V4H6V2.99775H14V4H15V2.99775H19.0023V6H0.99775V2.99775ZM19.0023 17.0023H0.99775V7H19.0023V17.0023Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaFilter);
export default __webpack_public_path__ + "static/media/calendaFilter.065a9d8c2659d63ae39e53e31898f25c.svg";
export { ForwardRef as ReactComponent };